import React from 'react';

import { ImageFit } from '@fluentui/react/lib/Image';

import { SmartImageConnector as SmartImage } from '../../src/smart-image-connector';

export const ImageItemView = props => (
  <SmartImage
    imageFit={ImageFit.contain}
    maximizeFrame
    {...props}
  />
);
